import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Col, Container, Row, Button, FormGroup, Modal,
  ModalHeader,
  ModalBody,
  ModalFooter, } from "reactstrap";
import { ReactstrapInput, ReactstrapSelect } from "reactstrap-formik";
import { Spinner } from "reactstrap";

import * as Yup from "yup";

import FormHelpers from "../../helpers/FormHelpers";
import ScrollToFieldError from "./Validation/ScrollToFieldError";
import CardPreview from "../Cards/CardPreview";
import AddressBook from "../AddressBook/AddressBook";

import config from "../../store/config";
import { configuratorActions } from "../../store/configurator-slice";
import { cardPreviewActions } from "../../store/card-preview-slice";
import { addressBookActions } from "../../store/address-book-slice";
import { fetchConfiguratorData } from "../../store/configurator-actions";
import BillingLoginForm from "./BillingLoginForm";

if (typeof window.SMA_DEFAULT_CONFIG !== "undefined") {
  config.settings = window.SMA_DEFAULT_CONFIG;
}

function RecipientForm(props) {

  const dispatch = useDispatch();

  // get current request state
  const formStep = useSelector((state) => state.configurator.FormStep);
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;

  // set sendTo state

  const isLoggedIn = currentRequest.DonorIsLoggedIn;

  // set sendTo state
  const [sendToValue, setSendToValue] = useState(
    isLoggedIn ? "custom" : (requestDetails.SendTo ? requestDetails.SendTo : "billing")
  );

  // get title list
  const titles = currentRequest.Lists.DonorTitles;
  const titlesArray = titles.map((item) => {
    return item.Value;
  });

  // get country list
  const countries = currentRequest.Lists.Countries;
  const countriesArray = countries.map((item) => {
    return item.Value;
  });

  // get state list
  const states = currentRequest.Lists.States;
  const statesArray = states.map((item) => {
    return item.Value;
  });

  // get province list
  const provinces = currentRequest.Lists.Provinces;
  const provincesArray = provinces.map((item) => {
    return item.Value;
  });

  const [showAddressBook, setShowAddressBook] = useState(false);
  const [showBillingLoginModal, setShowBillingLoginModal] = useState(false);
  

  // init form validation schema
  let formSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    address1: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
    state: Yup.string().when("country", (country) => {
      if (country === "USA") return Yup.string().required("Required");
    }),
    province: Yup.string().when("country", (country) => {
      if (country === "Canada") return Yup.string().required("Required");
    }),
    city: Yup.string().required("Required"),
    postalCode: Yup.string().when("country", (country) => {
      if (country === "USA" || country === "Canada") {
        if (country === "USA") {
          return Yup.string()
            .required("Required")
            .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, "Must be a valid zip code");
        } else {
          return Yup.string()
            .required("Required")
            .matches(
              /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z][ -]?[0-9][A-Z][0-9]$/,
              "Must be a valid postal code"
            );
        }
      }
    }),
  });

  // set sendTo address state
  const [sendToAddress, setSendToAddress] = useState({
    RecipientTitle: requestDetails.RecipientTitle,
    RecipientFirstName: requestDetails.RecipientFirstName,
    RecipientLastName: requestDetails.RecipientLastName,
    RecipientAddress1: requestDetails.RecipientAddress1,
    RecipientAddress2: requestDetails.RecipientAddress2,
    RecipientCountry: requestDetails.RecipientCountry
      ? requestDetails.RecipientCountry
      : "USA",
    RecipientStateProvince: requestDetails.RecipientStateProvince,
    RecipientCity: requestDetails.RecipientCity,
    RecipientZipPostalCode: requestDetails.RecipientZipPostalCode,
  });

  useEffect(() => {
    if (
      isLoggedIn &&
      requestDetails.CardTypeValue === "sendtome" &&
      !requestDetails.RecipientFirstName
    ) {
      setSendToValue("custom");
      setSendToAddress({
        RecipientTitle: currentRequest.DonorInfo.Title,
        RecipientFirstName: currentRequest.DonorInfo.FirstName,
        RecipientLastName: currentRequest.DonorInfo.LastName,
        RecipientAddress1: currentRequest.DonorInfo.Address1,
        RecipientAddress2: currentRequest.DonorInfo.Address2,
        RecipientCountry: currentRequest.DonorInfo.Country,
        RecipientStateProvince: currentRequest.DonorInfo.StateProvince,
        RecipientCity: currentRequest.DonorInfo.City,
        RecipientZipPostalCode: currentRequest.DonorInfo.PostalCode,
      });
    }
  }, []);

  useEffect(() => {
    if (
      isLoggedIn &&
      requestDetails.CardTypeValue === "sendtome" &&
      !requestDetails.RecipientFirstName
    ) {
      setSendToValue("custom");
      setSendToAddress({
        RecipientTitle: currentRequest.DonorInfo.Title,
        RecipientFirstName: currentRequest.DonorInfo.FirstName,
        RecipientLastName: currentRequest.DonorInfo.LastName,
        RecipientAddress1: currentRequest.DonorInfo.Address1,
        RecipientAddress2: currentRequest.DonorInfo.Address2,
        RecipientCountry: currentRequest.DonorInfo.Country,
        RecipientStateProvince: currentRequest.DonorInfo.StateProvince,
        RecipientCity: currentRequest.DonorInfo.City,
        RecipientZipPostalCode: currentRequest.DonorInfo.PostalCode,
      });
    }
  }, [isLoggedIn]);

  const sendToClickHandler = (e) => {
    setSendToValue(e.target.value);
    if (e.target.value === "custom") {
      setSendToAddress({
        RecipientTitle: "",
        RecipientFirstName: "",
        RecipientLastName: "",
        RecipientAddress1: "",
        RecipientAddress2: "",
        RecipientCountry: "",
        RecipientStateProvince: "",
        RecipientCity: "",
        RecipientZipPostalCode: "",
      });
    } else {
      setSendToAddress({
        RecipientTitle: currentRequest.DonorInfo.Title,
        RecipientFirstName: currentRequest.DonorInfo.FirstName,
        RecipientLastName: currentRequest.DonorInfo.LastName,
        RecipientAddress1: currentRequest.DonorInfo.Address1,
        RecipientAddress2: currentRequest.DonorInfo.Address2,
        RecipientCountry: currentRequest.DonorInfo.Country,
        RecipientStateProvince: currentRequest.DonorInfo.StateProvince,
        RecipientCity: currentRequest.DonorInfo.City,
        RecipientZipPostalCode: currentRequest.DonorInfo.PostalCode,
      });
    }
    dispatch(cardPreviewActions.setFieldFocus(""));
  };

  const previousClickHandler = (values) => {
    dispatch(configuratorActions.setFormStep("Personalize"));
    dispatch(cardPreviewActions.setFieldFocus(""));
    FormHelpers.scrollToTop();
  };

  const inputFocusHandler = (e) => {
    dispatch(cardPreviewActions.setFieldFocus("envelope-recipient"));
  };

  const inputBlurHandler = (e) => {
    dispatch(cardPreviewActions.setFieldFocus(""));
  };

  const formRef = useRef();
  const addressUpdateHandler = (e) => {
    let values = { ...formRef.current.values };
    values[e.target.name] = e.target.value;

    updateEnvelopeDisplay(values);
  };

  const addressUpdateFromAddressBookHandler = (address) => {
    setSendToValue("custom");

    // Create a complete address object with all required fields
    const updatedAddress = {
      RecipientTitle: address.Title,
      RecipientFirstName: address.FirstName,
      RecipientLastName: address.LastName,
      RecipientAddress1: address.Address1,
      RecipientAddress2: address.Address2,
      RecipientCountry: address.Country,
      RecipientStateProvince: address.StateProvince,
      RecipientCity: address.City,
      RecipientZipPostalCode: address.ZipPostalCode,
    };

    setSendToAddress(updatedAddress);

    // Update form values
    if (formRef.current) {
      formRef.current.setValues({
        ...formRef.current.values,
        title: address.Title,
        firstName: address.FirstName,
        lastName: address.LastName,
        address1: address.Address1,
        address2: address.Address2,
        country: address.Country,
        state: address.Country === "USA" ? address.StateProvince : "",
        province: address.Country === "Canada" ? address.StateProvince : "",
        city: address.City,
        postalCode: address.ZipPostalCode,
      });
    }

    let previewValues = {
      title: address.Title,
      firstName: address.FirstName,
      lastName: address.LastName,
      address1: address.Address1,
      address2: address.Address2,
      country: address.Country,
      state: address.Country === "USA" ? FormHelpers.getStateProvinceCode(states, address.StateProvince) : "",
      province: address.Country === "Canada" ? FormHelpers.getStateProvinceCode(provinces, address.StateProvince) : "",
      city: address.City,
      postalCode: address.ZipPostalCode,
    };

    dispatch(cardPreviewActions.setEnvelopeRecipientAddress(previewValues));
    toggleAddressBook(false);
  };

  function toggleAddressBook(show) {
    setShowAddressBook(show);
  }

  const addToAddressBookClickHandler = (values) => {
    let address = {
      Title: values.title,
      FirstName: values.firstName,
      LastName: values.lastName,
      Address1: values.address1,
      Address2: values.address2,
      Country: values.country,
      StateProvince: values.country === "USA" ? values.state : 
                     values.country === "Canada" ? values.province : "",
      City: values.city,
      ZipPostalCode: values.postalCode,
    };

    // Get the user ID from the current request's donor info
    address.UserId = currentRequest.DonorInfo.id;  // Make sure to use the correct property name

    // Store the address in Redux state before showing the address book
    dispatch(addressBookActions.setAddingAddress(address));
    setShowAddressBook(true);
  };

  // START ADDRESS VERIFICATION
  const [sessionToken, setSessionToken] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [selectedPlaceId, setSelectedPlaceId] = useState(null);
  const [nextButtonLabel, setNextButtonLabel] = useState("Next");
  const [addressVerifyMessage, setAddressVerifyMessage] = useState("");
  const [focusedSuggestionIndex, setFocusedSuggestionIndex] = useState(-1);
  const [isSuggestionListFocused, setIsSuggestionListFocused] = useState(false);
  const [useAddressAsEntered, setUseAddressAsEntered] = useState(false);
  const [verifiedAddressValues, setVerifiedAddressValues] = useState(null);
  const [showAddressCorrectionModal, setShowAddressCorrectionModal] = useState(false);
  const [addressCorrectionModalMsg, setAddressCorrectionModalMsg] = useState(null);
  const toggleAddressCorrectionModal = (e) => {
    setShowAddressCorrectionModal(!showAddressCorrectionModal);
  };

  // Refs to Google services
  const autocompleteServiceRef = useRef(null);
  const placesServiceRef = useRef(null);
  const suggestionsRef = useRef(null);
  const inputRef = useRef(null);

  // Get a reference to the input element after render
  useEffect(() => {
    // Find the input element inside the Field component
    const inputElement = document.getElementById('address1');
    if (inputElement) {
      inputRef.current = inputElement;
    }
  }, []);

  // Initialize Google services once the script has loaded
  useEffect(() => {
    if (window.google) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();

      // PlacesService needs a DOM node or a map, so we can create an offscreen <div>
      const offscreenDiv = document.createElement("div");
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        offscreenDiv
      );
    }
  }, []);

  const generateNewSessionToken = () => {
    let token = { gw: "" };
    if (window.google && window.google.maps && window.google.maps.places) {
      token = new window.google.maps.places.AutocompleteSessionToken();
      setSessionToken(token);
    }
    return token;
  };

  useEffect(() => {
    generateNewSessionToken();

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Add debouncing to reduce API calls
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 150); // 150ms delay

    return () => clearTimeout(timer);
  }, [inputValue]);

  // Modify address1UpdateHandler to check for special keys
  const address1UpdateHandler = (e) => {
    const { value } = e.target;
    
    // Don't update input value or trigger API calls for special keys
    if (e.key === 'Backspace' || e.key === 'Enter' || e.key === ' ') {
      formRef.current.setFieldValue("address1", value);
      addressUpdateHandler(e);
      return;
    }

    setInputValue(value);
    formRef.current.setFieldValue("address1", value);

    // If empty, reset suggestions
    if (!value) {
      setSuggestions([]);
      return;
    }

    // Check if the last character entered is alphanumeric
    const lastChar = value[value.length - 1];
    const isAlphanumeric = /^[a-zA-Z0-9]$/.test(lastChar);

    // If not alphanumeric, clear suggestions
    if (!isAlphanumeric) {
      setSuggestions([]);
    }

    addressUpdateHandler(e);
    setFocusedSuggestionIndex(-1);
  };

  // Modify the debounced effect to also check for special keys
  useEffect(() => {
    if (!debouncedValue || debouncedValue.length < 3) return;

    // Check if the last character is alphanumeric
    const lastChar = debouncedValue[debouncedValue.length - 1];
    const isAlphanumeric = /^[a-zA-Z0-9]$/.test(lastChar);
    
    // Don't make API call if last character is not alphanumeric
    if (!isAlphanumeric) return;

    if (autocompleteServiceRef.current && sessionToken) {
      autocompleteServiceRef.current.getPlacePredictions(
        {
          input: debouncedValue,
          sessionToken: sessionToken
        },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setSuggestions(predictions);
          } else {
            setSuggestions([]);
          }
        }
      );
    }
  }, [debouncedValue, sessionToken]);

  const formatAddressString = (addressString) => {
    const replacements = [
      { pattern: /street/gi, replacement: 'St' },
      { pattern: /drive/gi, replacement: 'Dr' },
      { pattern: /avenue/gi, replacement: 'Ave' },
      { pattern: /boulevard/gi, replacement: 'Blvd' },
      { pattern: /circle/gi, replacement: 'Cir' },
      { pattern: /court/gi, replacement: 'Ct' },
      { pattern: /square/gi, replacement: 'Sq' },
      { pattern: /place/gi, replacement: 'Pl' },
      { pattern: /road/gi, replacement: 'Rd' },
      { pattern: /lane/gi, replacement: 'Ln' },
      { pattern: /trak/gi, replacement: 'Trk' }
    ];
  
    let formattedAddress = addressString;
    replacements.forEach(({ pattern, replacement }) => {
      formattedAddress = formattedAddress.replace(pattern, replacement);
    });
  
    return formattedAddress;
  };

  // Called when user clicks on one of the suggestions
  const handleSuggestionClick = (suggestion) => {
    // First, clear all suggestion-related states
    setSuggestions([]);
    setFocusedSuggestionIndex(-1);
    setIsSuggestionListFocused(false);
    setInputValue(''); // Clear input value to prevent debounced effect

    // Set the selected place ID
    setSelectedPlaceId(suggestion.place_id);

    // Immediately fetch full place details to populate city, state, etc.
    if (placesServiceRef.current && suggestion.place_id) {
      placesServiceRef.current.getDetails(
        { placeId: suggestion.place_id },
        (place, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            place
          ) {
            // Parse address components
            let address1 = "";
            let city = "";
            let stateOrProvince = "";
            let postalCode = "";
            let country = "";
            
            if (place.address_components) {
              place.address_components.forEach((component) => {
                const types = component.types;
                if (types.includes("street_number")) {
                  address1 = component.long_name;
                }
                if (types.includes("route")) {
                  address1 += " " + component.long_name;
                }
                if (types.includes("locality")) {
                  city = component.long_name;
                }
                if (types.includes("administrative_area_level_1")) {
                  stateOrProvince = component.long_name;
                }
                if (types.includes("country")) {
                  country = component.long_name;
                }
                if (types.includes("postal_code")) {
                  postalCode = component.long_name;
                }
              });
            }

            if(country === "United States") {
              country = "USA";
            }

            // Update all form fields at once
            formRef.current.setFieldValue("address1", address1);
            formRef.current.setFieldValue("city", city);
            formRef.current.setFieldValue("country", country);
            if(country === "USA") {
              formRef.current.setFieldValue("state", stateOrProvince);
            } else if(country === "Canada") {
              formRef.current.setFieldValue("province", stateOrProvince);
            } else {
              formRef.current.setFieldValue("city", city + ", " + stateOrProvince);
            }
            formRef.current.setFieldValue("postalCode", postalCode);

            let values = { 
              firstName: formRef.current.values.firstName,
              lastName: formRef.current.values.lastName,
              address1: address1,
              address2: '',
              city: city,
              state: stateOrProvince,
              province: stateOrProvince,
              country: country,
              postalCode: postalCode
            };

            let envelopeValues = { ...values };

            if (values.country === "USA") {
              envelopeValues.state = FormHelpers.getStateProvinceCode(
                states,
                values.state
              );
            } else if (values.country === "Canada") {
              envelopeValues.province = FormHelpers.getStateProvinceCode(
                provinces,
                values.province
              );
            }

            dispatch(cardPreviewActions.setEnvelopeRecipientAddress(envelopeValues));
          }
        }
      );
    }

    // Focus the input after selection
    inputRef.current?.focus();
  };

  // Handle keyboard navigation from the input field
  const handleInputKeyDown = (e) => {
    if (!suggestions.length) return;
    
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setFocusedSuggestionIndex(0);
        setIsSuggestionListFocused(true);
        // Focus the first suggestion item
        setTimeout(() => {
          const firstItem = suggestionsRef.current?.querySelector('li');
          if (firstItem) firstItem.focus();
        }, 10);
        break;
      case 'Tab':
        if (suggestions.length && !isSuggestionListFocused) {
          e.preventDefault();
          setFocusedSuggestionIndex(0);
          setIsSuggestionListFocused(true);
          // Focus the first suggestion item
          setTimeout(() => {
            const firstItem = suggestionsRef.current?.querySelector('li');
            if (firstItem) firstItem.focus();
          }, 10);
        }
        break;
      case 'Escape':
        e.preventDefault();
        setSuggestions([]);
        break;
      default:
        break;
    }
  };

  // Handle suggestion item keyboard navigation
  const handleSuggestionKeyDown = (e, suggestion, index) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (index < suggestions.length - 1) {
          setFocusedSuggestionIndex(index + 1);
          const items = suggestionsRef.current?.querySelectorAll('li');
          if (items && items[index + 1]) items[index + 1].focus();
        }
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (index > 0) {
          setFocusedSuggestionIndex(index - 1);
          const items = suggestionsRef.current?.querySelectorAll('li');
          if (items && items[index - 1]) items[index - 1].focus();
        } else {
          // Return focus to input when at the top of the list
          setFocusedSuggestionIndex(-1);
          setIsSuggestionListFocused(false);
          inputRef.current?.focus();
        }
        break;
      case 'Enter':
        e.preventDefault();
        handleSuggestionClick(suggestion);
        // Clear suggestions and reset states
        setSuggestions([]);
        setFocusedSuggestionIndex(-1);
        setIsSuggestionListFocused(false);
        // Clear the input value to prevent the debounced effect from firing
        setInputValue('');
        break;
      case 'Escape':
        e.preventDefault();
        setSuggestions([]);
        setFocusedSuggestionIndex(-1);
        setIsSuggestionListFocused(false);
        inputRef.current?.focus();
        break;
      case 'Tab':
        // Allow normal tab behavior to move to next form element
        setIsSuggestionListFocused(false);
        setSuggestions([]);
        break;
      default:
        break;
    }
  };

  const handleClickOutside = (event) => {
    if (
      suggestionsRef.current &&
      !suggestionsRef.current.contains(event.target)
    ) {
      setSuggestions([]); // Hide the suggestions box
    }
  };
  document.addEventListener("mousedown", handleClickOutside);

  // Add a new effect to watch for login state changes
  useEffect(() => {
    if (isLoggedIn) {
      // Generate a new session token when user logs in
      generateNewSessionToken();
    }
  }, [isLoggedIn]);

  // Modify the verifyAddressOnServer function to ensure we have a valid session token
  async function verifyAddressOnServer(values) {
    // Ensure we have a valid session token
    if (!sessionToken) {
      generateNewSessionToken();
    }
  
    // Get the token value from either property
    const tokenValue = sessionToken.gw || sessionToken.token;
  

    const body = {
      sessionToken: tokenValue,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      province: values.province,
      country: values.country,
      zip: values.postalCode,
    };

    console.log('body:', body);

    try {
      const response = await fetch(config.settings.apiEndpoint + "api/requests/VerifyAddress", {
        method: "POST",
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': window.AntiForgeryToken
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }

      const data = await response.json();
      return data.success 
        ? { success: true, standardizedAddress: data.standardizedAddress }
        : { success: false, error: data.error };
    } catch (err) {
      return { success: false, error: err.message };
    }
  }

  if(sendToValue === "billing") {
    formSchema = Yup.object().shape();
  }

  // Handler for "Update Address" button
  const handleUpdateAddress = () => {
    // Apply verified address to form fields
    if (verifiedAddressValues) {
      // Update form fields with verified values
      Object.entries(verifiedAddressValues).forEach(([field, value]) => {
        if(field != "address1" && field != "address2") {
          formRef.current.setFieldValue(field, value);
        }
      });
      
      // Submit the  form with verified values
      dispatch(configuratorActions.setRecipient(verifiedAddressValues));
      updateEnvelopeDisplay(verifiedAddressValues);
      dispatch(cardPreviewActions.setFieldFocus(""));
      FormHelpers.scrollToTop();
    }
    
    setShowAddressCorrectionModal(false);
  };

  // Handler for "Please use my address as entered"
  const useAddressAsEnteredHandler = () => {
    setUseAddressAsEntered(true);
    setShowAddressCorrectionModal(false);
    
    // Submit with current form values
    const currentValues = formRef.current.values;
    dispatch(configuratorActions.setRecipient(currentValues));
    updateEnvelopeDisplay(currentValues);
    dispatch(cardPreviewActions.setFieldFocus(""));
    FormHelpers.scrollToTop();
  };

  const updateEnvelopeDisplay = (values) => {

    let envelopeValues = { ...values };

    if (values.country === "USA") {
      envelopeValues.state = FormHelpers.getStateProvinceCode(
        states,
        values.state
      );
    } else if (values.country === "Canada") {
      envelopeValues.province = FormHelpers.getStateProvinceCode(
        provinces,
        values.province
      );
    }

    dispatch(cardPreviewActions.setEnvelopeRecipientAddress(envelopeValues));

  };

  const formSubmitHandler = async (values) => {
    setAddressVerifyMessage("");

    if (
      requestDetails.CardTypeValue === "sendtome" &&
      values.sendTo === "billing" &&
      !isLoggedIn
    ) {
      setShowBillingLoginModal(true);
      return;
    }
    
    dispatch(configuratorActions.setRecipient(values));
    dispatch(cardPreviewActions.setFieldFocus(""));
    FormHelpers.scrollToTop();
    return;

    // If we already have verified address values or user chose to use address as entered,
    // skip verification and submit directly
    if (verifiedAddressValues || useAddressAsEntered) {
      const finalValues = verifiedAddressValues || values;
      dispatch(configuratorActions.setRecipient(finalValues));
      dispatch(cardPreviewActions.setFieldFocus(""));
      FormHelpers.scrollToTop();
      return;
    }
    
    setNextButtonLabel("Please wait...");
    setShowAddressCorrectionModal(false);
    setAddressCorrectionModalMsg("");
          
    if(requestDetails.CardTypeValue != "sendtome" || (requestDetails.CardTypeValue == "sendtome" && sendToValue != "billing")) {
      const verifyResult = await verifyAddressOnServer(values);
  
      if (!verifyResult.success) {
        setNextButtonLabel("Next");
        setAddressVerifyMessage("We are unable to verify the entered address. Please confirm the correct address details and try again.");
        return;
      } else {
        // Update relevant Formik fields
        const verifiedAddress = verifyResult.standardizedAddress;
        const currentFormValues = formRef.current.values;
  
        // Create the verified values object
        let verifiedValues = { 
          firstName: currentFormValues.firstName,
          lastName: currentFormValues.lastName,
          title: currentFormValues.title,
          sendTo: currentFormValues.sendTo,
          address1: currentFormValues.address1,
          address2: currentFormValues.address2,
          city: verifiedAddress.locality,
          state: verifiedAddress.administrativeArea,
          province: verifiedAddress.administrativeArea,
          country: verifiedAddress.regionCode,
          postalCode: verifiedAddress.postalCode.split('-')[0]
        };
  
        // Store the verified values for later use
        setVerifiedAddressValues(verifiedValues);
  
        let envelopeValues = { ...verifiedValues };
  
        if (verifiedValues.country === "USA") {
          envelopeValues.state = FormHelpers.getStateProvinceCode(
            states,
            verifiedValues.state
          );
        } else if (verifiedValues.country === "Canada") {
          envelopeValues.province = FormHelpers.getStateProvinceCode(
            provinces,
            verifiedValues.province
          );
        }
  
        let addressMatchMsg = "";
        // if(FormHelpers.normalizeAddressForComparison(currentFormValues.address1) != FormHelpers.normalizeAddressForComparison(verifiedValues.address1)) {
        //   addressMatchMsg += "Address 1 will be changed to: <strong style=\"font-weight: 700\">" + verifiedValues.address1 + "</strong><br />";
        // }
        // if(FormHelpers.normalizeAddressForComparison(currentFormValues.address2) != FormHelpers.normalizeAddressForComparison(verifiedValues.address2)) {
        //   addressMatchMsg += "Address 2 will be changed to: <strong style=\"font-weight: 700\">" + verifiedValues.address2 + "</strong><br />";
        // }
        if(currentFormValues.city != verifiedValues.city) {
          addressMatchMsg += "City will be changed to: <strong style=\"font-weight: 700\">" + verifiedValues.city + "</strong><br />";
        }
        if(currentFormValues.state && currentFormValues.state != verifiedValues.state) {
          addressMatchMsg += "State will be changed to <strong style=\"font-weight: 700\">" + verifiedValues.state + "</strong><br />";
        }
        if(currentFormValues.province && currentFormValues.province != verifiedValues.province) {
          addressMatchMsg += "Province will be changed to <strong style=\"font-weight: 700\">" + verifiedValues.province + "</strong><br />";
        }
        if(currentFormValues.country != verifiedValues.country) {
          addressMatchMsg += "Country will be changed to <strong style=\"font-weight: 700\">" + verifiedValues.country + "</strong><br />";
        }
        if(currentFormValues.postalCode != verifiedValues.postalCode) {
          addressMatchMsg += "Postal code will be changed to <strong style=\"font-weight: 700\">" + verifiedValues.postalCode + "</strong><br />";
        }
  
        if(addressMatchMsg) {
          setShowAddressCorrectionModal(true);
          setAddressCorrectionModalMsg("To improve shipping accuracy, a suggested address update was found based on your entered address. Please see below for details and confirmation: <br /><br />" + addressMatchMsg);
          setNextButtonLabel("Next");
          return;
        } else {
          // If no changes needed, submit with verified values
          dispatch(cardPreviewActions.setEnvelopeRecipientAddress(envelopeValues));
          dispatch(configuratorActions.setRecipient(verifiedValues));
          dispatch(cardPreviewActions.setFieldFocus(""));
          FormHelpers.scrollToTop();
          return;
        }
      }
    }
  
    // For billing address or if no verification needed
    dispatch(configuratorActions.setRecipient(values));
    dispatch(cardPreviewActions.setFieldFocus(""));
    FormHelpers.scrollToTop();
  };

  const billingLoginSuccessHandler = (donorInfo) => {
    setShowBillingLoginModal(false);

    setSendToValue("custom");
    setSendToAddress({
      RecipientTitle: donorInfo.title || "",
      RecipientFirstName: donorInfo.firstName || "",
      RecipientLastName: donorInfo.lastName || "",
      RecipientAddress1: donorInfo.address1 || "",
      RecipientAddress2: donorInfo.address2 || "",
      RecipientCountry: donorInfo.country || "USA",
      RecipientStateProvince: donorInfo.stateProvince || "",
      RecipientCity: donorInfo.city || "",
      RecipientZipPostalCode: donorInfo.postalCode || "",
    });
  };

  // END ADDRESS VERIFICATION

  return (
    <div className="cfg-input-form cfg-recipient" data-step="recipient">
      <Formik
        enableReinitialize={true}
        initialValues={{
          sendTo: sendToValue,
          title: sendToAddress.RecipientTitle,
          firstName: sendToAddress.RecipientFirstName,
          lastName: sendToAddress.RecipientLastName,
          address1: sendToAddress.RecipientAddress1,
          address2: sendToAddress.RecipientAddress2,
          country: sendToAddress.RecipientCountry
            ? sendToAddress.RecipientCountry
            : "USA",
          state: sendToAddress.RecipientStateProvince,
          province: sendToAddress.RecipientStateProvince,
          city: sendToAddress.RecipientCity,
          postalCode: sendToAddress.RecipientZipPostalCode,
        }}
        validationSchema={formSchema}
        onSubmit={formSubmitHandler}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue
        }) => (
          <Form className="text-start">
            <ScrollToFieldError />
            <Container className="cfg-form-section">
              <Row className="mobile-only">
                <Col xs="12">
                  <CardPreview
                    zoom={0.57}
                    showCard={false}
                    showEnvelope={true}
                    preview={true}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="12" className="text-center">
                  <Button
                    type="button"
                    size="lg"
                    color="primary"
                    onClick={() => toggleAddressBook(true)}
                  >
                    Display Address Book
                  </Button>
                </Col>
              </Row>

              {requestDetails.CardTypeValue == "sendtome" && !isLoggedIn && (
                <Row>
                  <Col xs="12">
                    <FormGroup>
                      <div className="form-check">
                        <label>
                          <Field
                            type="radio"
                            name="sendTo"
                            value="billing"
                            onClick={sendToClickHandler}
                          />
                          My billing name and address
                        </label>
                      </div>
                      <div className="form-check">
                        <label>
                          <Field
                            type="radio"
                            name="sendTo"
                            value="custom"
                            onClick={sendToClickHandler}
                          />
                          I will enter a name and address for this request
                        </label>
                      </div>
                      {errors.sendTo && touched.sendTo && (
                        <div className="invalid-feedback">{errors.sendTo}</div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              )}

              {requestDetails.CardTypeValue == "sendtome" && !isLoggedIn && values.sendTo == "billing" && <Row className="mb-3">
                <Col xs="12" className="text-center">
                  <p style={{ fontSize: '13px', fontWeight: 600 }}>You will be asked to log in to your account to confirm your billing address.</p>
                </Col>
              </Row>}

              {(requestDetails.CardTypeValue != "sendtome" || (requestDetails.CardTypeValue == "sendtome" && values.sendTo != "billing")) && <><Row className="mb-2">
                <Col xs="12">
                  <label htmlFor="title">Title:</label>
                  <Field
                    name="title"
                    component={ReactstrapSelect}
                    onChange={(e) => {
                      handleChange(e);
                      addressUpdateHandler(e);
                    }}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      handleBlur(e);
                      inputBlurHandler(e);
                    }}
                    inputprops={{
                      name: "title",
                      id: "title",
                      options: titlesArray,
                      defaultOption: "Select...",
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="12">
                  <label className="required" htmlFor="firstName">
                    First Name:
                  </label>
                  <Field
                    name="firstName"
                    id="firstName"
                    maxLength="30"
                    component={ReactstrapInput}
                    onKeyUp={addressUpdateHandler}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      inputBlurHandler(e);
                      handleBlur(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="12">
                  <label className="required" htmlFor="lastName">
                    Last Name:
                  </label>
                  <Field
                    name="lastName"
                    id="lastName"
                    maxLength="30"
                    component={ReactstrapInput}
                    onKeyUp={addressUpdateHandler}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      handleBlur(e);
                      inputBlurHandler(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="12">
                  <label className="required" htmlFor="address1">
                    Address 1:
                  </label>
                  <Field
                    name="address1"
                    id="address1"
                    maxLength="50"
                    autoComplete="off"
                    component={ReactstrapInput}
                    onKeyUp={(e) => {
                      address1UpdateHandler(e);
                    }}
                    onKeyDown={handleInputKeyDown}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      if (!isSuggestionListFocused) {
                        setTimeout(() => {
                          handleBlur(e);
                          inputBlurHandler(e);
                        }, 100);
                      }
                    }}
                  />
                  {suggestions.length > 0 && (
                    <ul
                      ref={suggestionsRef}
                      role="listbox"
                      tabIndex={-1}
                      aria-label="Address suggestions"
                      style={{
                        position: "absolute",
                        background: "#fff",
                        border: "1px solid #ccc",
                        margin: 0,
                        padding: 0,
                        listStyle: "none",
                        width: "300px",
                        maxHeight: "150px",
                        overflowY: "auto",
                        zIndex: 999,
                      }}
                      onMouseDown={(e) => {
                        // Prevent blur event on input when clicking the list
                        e.preventDefault();
                      }}
                    >
                      {suggestions.map((suggestion, index) => (
                        <li
                          key={suggestion.place_id}
                          id={`suggestion-${suggestion.place_id}`}
                          role="option"
                          aria-selected={focusedSuggestionIndex === index}
                          tabIndex={0}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            backgroundColor: focusedSuggestionIndex === index ? "#e9ecef" : "transparent",
                            outline: "none", // Remove default focus outline
                          }}
                          onClick={() => handleSuggestionClick(suggestion)}
                          onKeyDown={(e) => handleSuggestionKeyDown(e, suggestion, index)}
                          onFocus={() => {
                            setFocusedSuggestionIndex(index);
                            setIsSuggestionListFocused(true);
                          }}
                          onBlur={() => {
                            // Only reset if we're not focusing another suggestion
                            setTimeout(() => {
                              if (!suggestionsRef.current?.contains(document.activeElement)) {
                                setIsSuggestionListFocused(false);
                                setSuggestions([]);
                              }
                            }, 100);
                          }}
                        >
                          {suggestion.description}
                        </li>
                      ))}
                    </ul>
                  )}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="12">
                  <label htmlFor="address2">Address 2:</label>
                  <Field
                    name="address2"
                    id="address2"
                    maxLength="50"
                    component={ReactstrapInput}
                    onKeyUp={addressUpdateHandler}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      handleBlur(e);
                      inputBlurHandler(e);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs="12">
                  <label className="required" htmlFor="country">
                    Country:
                  </label>
                  <Field
                    name="country"
                    component={ReactstrapSelect}
                    inputprops={{
                      name: "country",
                      id: "country",
                      options: countriesArray,
                      defaultOption: "Select...",
                    }}
                    onChange={(e) => {
                      handleChange(e);
                      addressUpdateHandler(e);
                    }}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      handleBlur(e);
                      inputBlurHandler(e);
                    }}
                  />
                </Col>
              </Row>
              {values.country === "USA" && (
                <Row className="mb-2">
                  <Col xs="12">
                    <label
                      className={values.country === "USA" ? "required" : ""}
                      htmlFor="state"
                    >
                      State:
                    </label>
                    <Field
                      name="state"
                      component={ReactstrapSelect}
                      inputprops={{
                        name: "state",
                        id: "state",
                        options: statesArray,
                        defaultOption: "Select...",
                      }}
                      onChange={(e) => {
                        handleChange(e);
                        addressUpdateHandler(e);
                      }}
                      onFocus={inputFocusHandler}
                      onBlur={(e) => {
                        handleBlur(e);
                        inputBlurHandler(e);
                      }}
                    />
                  </Col>
                </Row>
              )}

              {values.country === "Canada" && (
                <Row className="mb-2">
                  <Col xs="12">
                    <label
                      className={values.country === "Canada" ? "required" : ""}
                      htmlFor="province"
                    >
                      Province:
                    </label>
                    <Field
                      name="province"
                      component={ReactstrapSelect}
                      inputprops={{
                        name: "province",
                        id: "province",
                        options: provincesArray,
                        defaultOption: "Select...",
                      }}
                      onChange={(e) => {
                        handleChange(e);
                        addressUpdateHandler(e);
                      }}
                      onFocus={inputFocusHandler}
                      onBlur={(e) => {
                        handleBlur(e);
                        inputBlurHandler(e);
                      }}
                    />
                  </Col>
                </Row>
              )}
              <Row className="mb-2">
                <Col xs="6">
                  <label className="required" htmlFor="city">
                    City:
                  </label>
                  <Field
                    name="city"
                    id="city"
                    maxLength="50"
                    component={ReactstrapInput}
                    onKeyUp={addressUpdateHandler}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      handleBlur(e);
                      inputBlurHandler(e);
                    }}
                  />
                </Col>
                <Col xs="6">
                  <label
                    className={
                      values.country === "USA" || values.country === "Canada"
                        ? "required"
                        : ""
                    }
                    htmlFor="postalCode"
                  >
                    Zip/Postal Code:
                  </label>
                  <Field
                    name="postalCode"
                    id="postalCode"
                    maxLength="10"
                    component={ReactstrapInput}
                    onKeyUp={addressUpdateHandler}
                    onFocus={inputFocusHandler}
                    onBlur={(e) => {
                      handleBlur(e);
                      inputBlurHandler(e);
                    }}
                  />
                </Col>
              </Row>
              {Object.keys(touched).length > 0 &&
                Object.keys(errors).length === 0 && (
                  <Row className="mb-2">
                    <Col xs="12" className="text-center">
                      <a onClick={() => addToAddressBookClickHandler(values)}>
                        Add Recipient to My Address Book
                      </a>
                    </Col>
                  </Row>
                )}</>}

            </Container>
            <Button
              type="button"
              size="sm"
              color="primary"
              onClick={previousClickHandler}
              className="btn-secondary"
            >
              Previous
            </Button>{" "}
            <Button
              type="submit"
              size="sm"
              color="primary"
              className="float-end"
              disabled={nextButtonLabel != "Next"}
            >
              {nextButtonLabel}
            </Button>
            {addressVerifyMessage != "" && <div className="alert alert-danger" role="alert">{addressVerifyMessage}</div>}

            <Modal
              isOpen={showAddressCorrectionModal}
              toggle={toggleAddressCorrectionModal}
              size="md"
              backdrop="static"
            >
              <ModalHeader toggle={toggleAddressCorrectionModal} close={() => null}>
                Address Update
              </ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    <Col>
                      <p
                        dangerouslySetInnerHTML={{ __html: addressCorrectionModalMsg }}
                        style={{ fontSize: '16px' }}
                      />
                    </Col>
                  </Row>
                </Container>
              </ModalBody>
              <ModalFooter style={{ flexDirection: 'column' }}>
                <Button
                  color="primary"
                  onClick={handleUpdateAddress}
                >
                  Update Address
                </Button>
                <a 
                  onClick={useAddressAsEnteredHandler} 
                  style={{ 
                    display: 'block', 
                    marginTop: '10px', 
                    color: '#337ab7', 
                    textDecoration: 'underline', 
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}
                >
                  Please use my address as entered
                </a>
              </ModalFooter>
            </Modal>
          </Form>
        )}
      </Formik>

      {showAddressBook && (
        <AddressBook
          formStep={formStep}
          showAddressBook={showAddressBook}
          onToggleAddressBookClickHandler={toggleAddressBook}
          onSelectClickHandler={addressUpdateFromAddressBookHandler}
        />
      )}
      {nextButtonLabel != "Next" && <Spinner color="primary">Verifying Address...</Spinner>}

      <BillingLoginForm
        isOpen={showBillingLoginModal}
        onClose={() => setShowBillingLoginModal(false)}
        onLoginSuccess={billingLoginSuccessHandler}
      />
    </div>
  );
}

export default RecipientForm;
